import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/app.config";
import { ErrorHandlerService } from "../errorHandler.service";
import { ReferenciasGerenciadas } from "src/app/models/ReferenciasGerenciadas";
import { firstValueFrom, tap } from "rxjs";
import { StorageService } from "../storage.service";
import { DataControleRepositorio } from "src/app/repositorios/dataControle.repositorio";
import { EnumTipoDataControle } from "src/app/enums/EnumDataControle";

@Injectable()
export class UsuarioReferenciasGerenciadasService {
  readonly databaseName = "svdm";
  readonly collectionName = "referencias-gereciada-conteudo";

  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    private storageService: StorageService,
    private dataControleRepositorio: DataControleRepositorio
  ) {}

  public async carregarReferenciasGerenciadasPorLei(
    leiId: string
  ): Promise<ReferenciasGerenciadas> {
    const url = `${AppConfig.apiEndpoint}/Referencias/ReferenciasGerenciadas`;
    let requestParams = new HttpParams();
    let referenciasGerenciadas: ReferenciasGerenciadas;

    const referencialocal: ReferenciasGerenciadas =
      await this.buscarReferenciaGerenciadaLocal(leiId);

    if (referencialocal) {
      const cache = await this.VerificaCacheReferenciasGerenciadas();

      if (cache) {
        return referencialocal;
      }
    }

    requestParams = requestParams.append("IdLei", leiId);
    requestParams = requestParams.append(
      "DataUltimaAtualizacao",
      // referencia ? referencia.dataUltimaAtualizacao :
      new Date(0).toISOString()
    );
    await firstValueFrom(
      this.httpClient
        .get<ReferenciasGerenciadas>(url, { params: requestParams })
        .pipe(
          tap({
            next: (result: ReferenciasGerenciadas) => {
              if (result) {
                const referen = new ReferenciasGerenciadas(result);
                this.salvarReferenciasGerenciadasLocal(referen).catch(
                  (error) => {
                    this.errorHandlerService.handleError(error);
                  }
                );
                referenciasGerenciadas = referen;
                this.dataControleRepositorio
                  .salvar(
                    this.dataControleRepositorio.generateDataControleTipo(
                      EnumTipoDataControle.DataVerificacaoCacheReferenciasGerenciados
                    )
                  )
                  .then(() => {})
                  .catch((error) =>
                    this.errorHandlerService.handleError(error)
                  );
              } else {
                referenciasGerenciadas = new ReferenciasGerenciadas();
              }
            },

            error: (error) => {
              this.errorHandlerService.handleError(error);
              if (referencialocal) {
                referenciasGerenciadas = referencialocal;
              } else {
                referenciasGerenciadas = new ReferenciasGerenciadas();
              }
            },
          })
        )
    );

    return referenciasGerenciadas;
  }

  public async salvarReferenciasGerenciadasLocal(
    referencia: ReferenciasGerenciadas
  ): Promise<void> {
    await this.storageService
      .upsert<ReferenciasGerenciadas>(
        referencia,
        this.databaseName,
        this.collectionName
      )
      .catch((error) => this.errorHandlerService.handleError(error));
  }

  public async buscarReferenciasGerenciadasLocal(): Promise<
    ReferenciasGerenciadas[]
    > {
    return await this.storageService
      .list<ReferenciasGerenciadas>(this.databaseName, this.collectionName)
      .then((referencias: ReferenciasGerenciadas[]) => referencias)
      .catch((error) => {
        this.errorHandlerService.handleError(error);
        return new Array<ReferenciasGerenciadas>();
      });
  }

  public async buscarReferenciaGerenciadaLocal(
    leiId: string
  ): Promise<ReferenciasGerenciadas> {
    return await this.storageService
      .getByKey<ReferenciasGerenciadas>(
        leiId,
        this.databaseName,
        this.collectionName
      )
      .then((referencia: ReferenciasGerenciadas) => referencia)
      .catch((error) => {
        this.errorHandlerService.handleError(error);
        return new ReferenciasGerenciadas();
      });
  }

  private async VerificaCacheReferenciasGerenciadas(): Promise<boolean> {
    const lastDocumentsListCheck = await this.dataControleRepositorio.buscar(
      EnumTipoDataControle.DataVerificacaoCacheReferenciasGerenciados
    );
    const tempoEmMinutos = AppConfig.cacheConteudo;

    if (lastDocumentsListCheck) {
      const cacheConteudo: number = tempoEmMinutos * 60 * 1000;
      const ultimaModificacao: Date =
        lastDocumentsListCheck.dataHoraModificacao;
      const DataAtual: Date = new Date();

      if (DataAtual.getTime() - ultimaModificacao.getTime() < cacheConteudo) {
        return true;
      }
    }
    return false;
  }
}
